module.exports = __webpack_public_path__ + "img/program-experience.c2b51e68.jpg";